/* eslint-disable */
export const crewInitialsSelector = ({ nonAppCrew: { crewInitials: value = [] } }: any) => value;
export const totalCrewSelector = ({ nonAppCrew: { totalCrew: value = 0 } }: any) => value;
export const selectedCrewSelector = ({ nonAppCrew: { selectedCrew } }: any) => {
  // selectedCrew is null in the initial state; a destructuring `= {}` default only
  // applies to `undefined`, so coalesce null → {} before reading fields.
  const {
    id = 0,
    firstName = '',
    lastName = '',
    fullName = '',
    email = '',
    laborRate = null,
    phone = null,
    primaryPhone = '',
    primaryPhoneExtension = '',
  } = selectedCrew || {};
  return {
    id,
    firstName,
    lastName,
    fullName,
    email,
    laborRate,
    phone,
    primaryPhone,
    primaryPhoneExtension,
  };
};
export const crewDeletedSelector = ({ nonAppCrew: { crewDeleted: value = '' } }: any) => value;
export const fetchingCrewSelector = ({ nonAppCrew: { fetchingCrew: value = true } }: any) => value;
export const crewCreatedSelector = ({ nonAppCrew: { crewCreated: value = false } }: any) => value;
export const crewUpdatedSelector = ({ nonAppCrew: { crewUpdated: value = false } }: any) => value;
